import { FC } from 'react';
import Style from './ff-divider.module.scss';

type FFDividerProps = {
    className?: string;
};

export const FFDivider: FC<FFDividerProps> = ({ className }: FFDividerProps): JSX.Element => {
    return <hr className={`ff-my-0 ${Style.divider} ${className}`}></hr>;
};
